import { auth } from '../config/firebase';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.socialness.ai';

export interface LinkedInOrganizationLocation {
  country: string;
  city: string;
  geoLocation: string;
  locationType: string;
  localizedDescription: string;
  streetAddressFieldState: string;
}

export interface LinkedInOrganization {
  id: string;
  localizedName: string;
  vanityName: string;
  staffCountRange: string;
  organizationType: string;
  platform: string;
  type: string;
  locations?: LinkedInOrganizationLocation[];
}

export interface LinkedInTempOrgsResponse {
  success: boolean;
  organizations: LinkedInOrganization[];
  expiresAt: string;
}

/**
 * Fetch temporary LinkedIn organizations for the current user.
 * 
 * Returns:
 *   LinkedInTempOrgsResponse: The response containing organizations list and expiry
 */
export const fetchLinkedInTempOrganizations = async (): Promise<LinkedInTempOrgsResponse> => {
  try {
    const token = await auth.currentUser?.getIdToken();
    if (!token) {
      throw new Error('No authentication token available');
    }

    console.log('Fetching LinkedIn temp organizations...');
    
    const response = await fetch(`${API_URL}/management/accounts/linkedin/temp-orgs`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Unknown error');
      console.error(`Failed to fetch temp organizations: ${response.status} - ${errorText}`);
      throw new Error(`Failed to fetch LinkedIn organizations: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('LinkedIn temp organizations response:', data);
    
    if (!data.success) {
      throw new Error(data.message || 'Failed to fetch LinkedIn organizations');
    }

    return data;
  } catch (error) {
    console.error('Error fetching LinkedIn temp organizations:', error);
    throw error;
  }
};

/**
 * Connect selected LinkedIn pages to the user's account.
 * 
 * Args:
 *   selectedPageIds (string[]): Array of page IDs to connect
 * 
 * Returns:
 *   Promise<any>: The response from the connection API
 */
export const connectLinkedInPages = async (selectedPageIds: string[]): Promise<any> => {
  try {
    const token = await auth.currentUser?.getIdToken();
    if (!token) {
      throw new Error('No authentication token available');
    }

          console.log('Connecting LinkedIn pages:', selectedPageIds);
      
      const response = await fetch(`${API_URL}/management/accounts/linkedin/connect-pages`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          selectedPageIds
        })
      });

    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Unknown error');
      console.error(`Failed to connect organizations: ${response.status} - ${errorText}`);
              throw new Error(`Failed to connect LinkedIn pages: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('Connect organizations response:', data);
    
    return data;
  } catch (error) {
          console.error('Error connecting LinkedIn pages:', error);
    throw error;
  }
}; 